// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"S8-z"};